import { render, staticRenderFns } from "./ReadArticle.vue?vue&type=template&id=4f8d322a"
import script from "./ReadArticle.vue?vue&type=script&lang=js"
export * from "./ReadArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports